export const {
  VITE_API_URL: API_URL,
  VITE_GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID,
  VITE_INVOICES_SEVENER_FORM_URL: INVOICES_SEVENER_FORM_URL
} = import.meta.env;
